module.exports = __webpack_public_path__ + "static/media/front-end.3c087ee6.svg";